import React from 'react';

import {TestOrderStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getTestOrdersByContainerIdsSearchUrl} from 'sample-tests/ui/utils/testOrderSearchUtil';
import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';

interface TestOrdersLinkedToContainersArchiveBannerProps {
  containerIds: Array<string>;
}

export default function TestOrdersLinkedToContainersArchiveBanner(
  props: TestOrdersLinkedToContainersArchiveBannerProps
): JSX.Element | null {
  if (props.containerIds.length === 0) {
    return null;
  }
  return (
    <InlineBanner
      bannerType={InlineBannerType.WARNING}
      action={{
        actionType: InlineBannerActionType.CUSTOM,
        actionText: 'View test orders',
        actionHref: getTestOrdersByContainerIdsSearchUrl(props.containerIds, [
          TestOrderStatus.PENDING,
          TestOrderStatus.BLOCKED,
        ]),
      }}
      text="Any test orders linked to archived containers will be updated."
      supportingInfo={
        <div>Test orders in pending or blocked states will be unlinked from these containers.</div>
      }
    />
  );
}
